<template>
    <div>
        <h2 class='subtitle is-dark'>
            マッチング結果
        </h2>
        <div class='box'>
            <div v-if='entry'>
                <div v-if='loaded && match' class='result'>{{match}}さんとマッチングしました。</div>
                <img v-if='loaded && match' :src="`${publicPath}${img}`">
                <div v-if='loaded && match' v-html='quote'></div>
                <div v-if='loaded && !match' class='result'>マッチングしませんでした。。。</div>
                <img v-if='loaded && !match' :src="`${publicPath}${img}`">
                <div v-if='loaded && !match' v-html='quote'></div>
            </div>
            <div v-if='!entry'>無効なアクセスです。</div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            entry: false,
            condition: '',
            db: this.$store.state.db,
            loaded: false,
            match: '',
            img: '',
            quote: '',
            publicPath: process.env.BASE_URL,
        }
    },
    created(){
        if(this.$store.state.id && this.$store.state.uid)this.entry = true;
        this.db.doc(this.$store.state.id).collection('name').doc(this.$store.state.uid).get()
        .then(doc=>{
            let id = doc.data().match;
            if(id){
                this.db.doc(this.$store.state.id).collection('name').doc(id).get()
                .then(doc=>{
                    this.loaded = true;
                    let name = doc.data().name;
                    this.match = name;
                    this.setImage(true);
                })
            .catch(error=>{console.log('error2');this.error(error)});
            }else{
                this.loaded = true;
                this.setImage(false);
            }
        })
        .catch(error=>{console.log('error1');this.error(error)});
    },
    methods:{
        setImage: function(isHappy){
            let [happyImg,badImg] = this.imgSet();
            let [happyQ, badQ] = this.quoteSet();
            if(isHappy){
                this.img = this.randomArray(happyImg);
                this.quote = this.randomArray(happyQ);
            }else{
                this.img = this.randomArray(badImg);
                this.quote = this.randomArray(badQ);
            }
        },
        imgSet: function(){
            let h = [];
            let b = [];
            for(let i = 0; i < 6; i++){
                h.push(`img/result/good${i+1}.png`);
                b.push(`img/result/bad${i+1}.png`);
            }
            // 微妙に数が合わないので。。。
            b.push(`img/result/bad7.png`);
            return [h,b];
        },
        quoteSet: function(){
            let h = [
                `<blockquote>平和は微笑みから始まります。</blockquote><br>By マザー・テレサ`,
                `<blockquote>人は喜んで自己の望むものを信じるものだ。</blockquote>By ユリウス・カエサル`,
                `<blockquote>急がずに、だが休まずに。</blockquote>By ゲーテ`,
                `<blockquote>考えは豊かに、見た目は貧しく。</blockquote>By アンディー・ウォーホル`,
                `<blockquote>決断しないことは、ときとして間違った行動よりたちが悪い。</blockquote>By ヘンリー・フォード`,
                `<blockquote>愛に触れると誰でも詩人になる。</blockquote>By プラトン`,
                `<blockquote>行動を伴わない想像力は、何の意味も持たない。</blockquote>By チャップリン`,
                `<blockquote>愛されたいなら、愛し、愛らしくあれ。</blockquote>By ベンジャミン・フランクリン`,
                `<blockquote>愛とは、大きな愛情をもって小さなことをすることです。</blockquote>By マザー・テレサ`,
                `<blockquote>今日という一日は、明日という日の二日分の値打ちがある。</blockquote>By ベンジャミン・フランクリン`,
                `<blockquote>今日始めなかったことは、明日終わることはない。</blockquote>By ゲーテ`,
                `<blockquote>最も偉大な発明家は誰か。それは「偶然」である。</blockquote>By マーク・トウェイン`,
                `<blockquote>我思う、ゆえに我あり。</blockquote>By デカルト`,
                `<blockquote>賽（さい）は投げられた。</blockquote>By ユリウス・カエサル`,
            ];
            let b = [
                `<blockquote>変革せよ。変革を迫られる前に。</blockquote>By ジャック・ウェルチ`,
                `<blockquote>何事も成功するまでは不可能に思えるものである。</blockquote>By ネルソン・マンデラ`,
                `<blockquote>速度を上げるばかりが、人生ではない。</blockquote>By マハトマ・ガンジー`,
                `<blockquote>すべては練習のなかにある。</blockquote>By ペレ`,
                `<blockquote>下を向いていたら、虹を見つけることは出来ないよ。</blockquote>By チャップリン`,
                `<blockquote>すべては過程だ。結果ではない。</blockquote>By カール・ルイス`,
                `<blockquote>準備しておこう。チャンスはいつか訪れるものだ。</blockquote>By エイブラハム・リンカーン`,
                `<blockquote>幸せかどうかは、自分次第である。</blockquote>By アリストテレス`,
                `<blockquote>優秀な芸術家は模倣し、偉大な芸術家は盗む。</blockquote>By パブロ・ピカソ`,
                `<blockquote>困難の中に、機会がある。</blockquote>By アインシュタイン`,
                `<blockquote>生きるとは呼吸することではない。行動することだ。</blockquote>By ルソー`,
                `<blockquote>本当の世界は想像よりもはるかに小さい。</blockquote>By ニーチェ`,
                `<blockquote>あなたの傷を知恵に変えなさい。</blockquote>By オプラ・フィンフリー`,
                `<blockquote>私の歩みは遅いが、歩んだ道を引き返すことはない。</blockquote>By エイブラハム・リンカーン`,
                `<blockquote>自由とは、より良くなるための機会のことだ。</blockquote>By アルベール・カミュ`,
                `<blockquote>人間の運命は、自分の魂の中にある。</blockquote>By ヘロドトス`,
                `<blockquote>あら探しをするより改善策を見つけよ。不平不満など誰でも言える。</blockquote>By ヘンリー・フォード`,
            ];
            return [h,b];
        },
        randomArray: function(array){
            return array[Math.floor(Math.random() * array.length)];
        },
    }
}
</script>

<style scoped>
.result{
    font-size: 20px;
    font-weight: bold;
}
</style>